import {Avatar, Chip, Tooltip} from '@mui/material';
import React, {useEffect, useState} from 'react';
import config from 'src/config';
import Errors from 'src/modules/shared/error/errors';
import UserService from 'src/modules/user/userService';

function ChipUserView(props) {
  const {user, type, size, sx, preferChip} = props;

  // const goToProfit360 = () => {
  //   if (hasPermissionToRead) {
  //     getHistory().push(`/user/` + user.id);
  //   }
  // };
  const [record, setRecord] = useState<any>(null);
  const [initLoading, setInitLoading] = useState(true);
  const [imageLoadFailed, setImageLoadFailed] = useState(false);

  const init = async () => {
    try {
      setInitLoading(true);

      const id = user?.id;
      const isPreloaded = Boolean(id);
      let result = user;
      if (!isPreloaded && user) {
        result = await UserService.find(user);
      }
      setRecord(result);

      setInitLoading(false);
    } catch (error) {
      Errors.handle(error);
    }
  };

  useEffect(() => {
    init();
  }, [user?.id, user?.fullName, user?.email]);

  useEffect(() => {
    if (record?.id) {
      setImageLoadFailed(false);
    }
  }, [record?.id]);

  if (record && !initLoading) {
    const hasValidAvatar = record.avatars && record.avatars.length > 0 && record.avatars[0]?.privateUrl;

    if (type === 'chip') {
      return (
        <Tooltip followCursor title={record.email + (record.fullName ? ' - ' + record.fullName : '')}>
          <Chip
            avatar={
              <Avatar
                src={config.backendUrl + '/file/download?privateUrl=' + (hasValidAvatar ? record.avatars[0]?.privateUrl : '')}
                alt={record.fullName || record.email}
                imgProps={{onError: () => setImageLoadFailed(true)}}>
                {(record.fullName || record.email || '?').charAt(0).toUpperCase()}
              </Avatar>
            }
            label={record.fullName || record.email}
            onClick={() => console.log('click')}
            variant="outlined"
            color="primary"
          />
        </Tooltip>
      );
    }
    return (
      <Tooltip followCursor title={record.email + (record.fullName ? ' - ' + record.fullName : '')}>
        <Avatar
          style={{width: size, height: size}}
          src={config.backendUrl + '/file/download?privateUrl=' + (hasValidAvatar ? record.avatars[0]?.privateUrl : '')}
          alt={record.email + (record.fullName ? ' - ' + record.fullName : '')}
          imgProps={{onError: () => setImageLoadFailed(true)}}
          sx={sx}>
          {(record.fullName || record.email || '?').charAt(0).toUpperCase()}
        </Avatar>
      </Tooltip>
    );
  }

  return <div></div>;
}

export default ChipUserView;
